import { createIcon } from './icon';

export const CloseIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 4L4 12" />
    <path d="M4 4l8 8" />
  </svg>,
  'CloseIcon'
);
